import classNames from "classnames";
import styles from "./idw-table-container.less";

type IdwTableContainerProps = {
    className?: string;
    children: React.ReactNode | Array<React.ReactNode>;
};

export const IdwTableContainer = (props: IdwTableContainerProps) => {
    const { className, children } = props;

    return (
        <div className={classNames(styles.idwTableContainer, className ? className : "")}>
            {children}
        </div>
    );
};